module.exports = __webpack_public_path__ + "static/img/wellcome_title.b0b89a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sumire/img/wellcome_title.png
// module id = 3VdD
// module chunks = 2